<template>

<div  class="container-fluid">

<button v-if="stores.length == 0" @click="close()" class="btn btn-primary btn-block">CHIUDI</button>

<spinner v-bind:spinner='spinner'></spinner>
<alert-box class="mt-2 mb-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
<button v-if="stores.length == 0 && 1==0" @click="close()" class="btn btn-primary active ml-2">CHIUDI</button>
<bookingForm v-if="booking.form" @close="booking.form=false" v-bind:booking="booking"></bookingForm>
  
<div class="header_">
      
  
           
</div>

<div>          
<div class="mt-4" v-for="(card,store) in stores"  :key="store" >
   
 <div class= "table-responsive-sm table-container" >              

  <table class="table  table-bordered table-hover  table-sm" id="dataGrid">
    
    <thead>
     
    
      <tr v-if="!btn">

        <th class="text-center store"  :colspan="cols.length">
          <h4 >ESISTENZA</h4>
          <product-info  class="mt-1 mb-1" :productId="item.productId"></product-info> 
          
         
        </th>
      </tr>
    

      <tr>
        <th  class="text-center store"  :colspan="cols.length">
          
          
         <span class="text-center" >
            <i class="fas fa-store mr-3" aria-hidden="true"></i>
            {{card[0].store}}
        </span> 
         
        </th>

        
      </tr>
      <tr>
        <th v-if="index > 1" class="text-center"         
          v-bind:style="{  color: index > 3 ? 'black' : '', backgroundColor : index > 3 ? '#9ACD32':'' }"
          v-for="(col,index) in cols" :key="index">
              <span class="ml-3 ">{{col}}</span>         
        </th>
      </tr>
    </thead>

    <tbody>
      
    
      <tr :style="{backgroundColor: item.row == '1'  ? '#efeee7': 'white',color: item.row == '1'  ? 'green' : 'black',fontSize : item.row == '1' ? '24px':'20px',fontWeight: item.row == '1' ? 'bolder':'' }"  v-for="(item, index1) in card" :key="index1">
        
        <td 
        
        
        data-toggle="tooltip" 
        :title="setTableCellTitle(index,index1,card,store)" v-if="index > 1" 
        :class="[setTableCellClass(index,index1,card,store,item,col)]" 
        @dblclick="setData(item.storeId,item.colorId,col,index,item.Colore,item.store,item[col],store,item.row)" 
        :style="{cursor : setTableCellPointer(index,index1,card,store,item,col)}"           
        
        v-for="(col,index) in cols" :key="index">
        
        

            <div :style="{color: col == 'Colore' && item[col] != 'TOTALE' ? '#800000':''}"  class="text-right  stock_" >
              <label style="color:white"   v-if="index > 3 && index1 < card.length -1" class="info-icon mr-1">{{ col }}</label>
              <i v-if="item[col] > 0 && index > 3 && index1 < card.length -1"  :class="setCameraIcon(index,index1,card,item.colorId,col)" aria-hidden="true"></i>
             <strong> {{item[col]}}</strong>
              
            </div>                          

        </td>
      </tr>

     
    

    </tbody>
    
  </table>

<!-- Table -->
 </div>

<button v-if="!btn" @click="close()" class="btn btn-outline-primary btn-block_ ">CHIUDI</button>
<hr class="mt-3 mb-3">
</div>



</div>
</div>


</template>

<script>

import spinner            from '@/components/common/Spinner.vue';
import ProductInfo        from '@/components/product/ProductInfo.vue';
import bookingForm        from '@/components/product/BookingForm.vue';
import alertBox           from '@/components/common/AlertBox.vue';

import api from '@/api'


export default {
   props: ['item','btn','margin'],
   components: {
     ProductInfo,spinner,alertBox,bookingForm
   
  },
  data () {
    return {

    
      textCenter   : 'text-center',

      booking      : {
        'form'      : false,
        'colorId'   : 0,
        'color'     : '',
        'size'      : '',
        'storeId'   : 0,
        'senderId'  : 0,
        'productId' : 0,
        'done'      : false,
        'store'     : ''
      },

      
      total        : 0,
      cols         : [], 
      rows         : [],
      colors       : [],
      

      spinner      : false,
      stores       : [],
      msg          : {
        title  : '',
        body   : '',
        type   : 0
      },
      barcodes : [],
      cameras  : []

     
       
    }
  },
  mounted()
  {

    //$(this.$el).find('[data-toggle="tooltip"]').tooltip();
  },

  async created()
  { 
    
    this.spinner = true   
    const data      = {'productId' : this.item.productId, 
                       'storeId'   : this.item.storeId} 
    const sp        = {'sp' : 'spDinamicPivotStockNew'}
    const json      = Object.assign(data, sp);

    await api.post(json).then(res => {
      if(res.status==200)
        {

          const items = res.data.recordsets
          
          let tmp = []
          
          tmp.push('colorId') 
          tmp.push('storeId') 
          tmp.push('Colore') 
          
          tmp.push('Totale') 
           
          const size = items[items.length-2][0].sizeList.split('|')
          //const size = items[items.length-2][0].sizeList.split('|') 
          size.forEach(e => {
              tmp.push(e)  
          });
          this.stores = []
          const length = 2
          //const length = 3

          for (let i = 0; i < items.length - length; i++) {
                if(items[i].length > 1)
                {
                  this.stores.push(items[i])
                }
          }
                  
          //this.stores = items.filter(item => (item.length > 1))

          this.cols = tmp
          this.rows = items[0]
          
          this.barcodes = items[items.length-1]
         /* console.log(this.barcodes)*/

          //this.cameras  = items[items.length-1]
          //console.log(this.cameras)
          
          
        }
        else if(res.status==500)
        {
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = res.data
          this.msg.type = 1

         

        } 
        else
        {
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = res
          this.msg.type = 1
          
         
        } 
    }).catch(err => 
    {
      
      this.msg.title = 'ATTENZIONE '
      this.msg.body  = err.message
      this.msg.type = 1

    }).finally(() => {
      this.spinner = false
    });

  
  },
 
      

  methods: 
  {


    setCameraIcon(index,index1,card,colorId,size)
    {
      
      if(index > 3 && index1 < card.length -1)
      {
        for (let i = 0; i < this.barcodes.length - 1; i++) 
          {
            if(this.barcodes[i]['colorId'] == colorId && this.barcodes[i]['size'] == size && this.barcodes[i]['barcode'] == this.barcodes[i]['cameraIcon'] )
            {
            
              return 'fas fa-camera float-left'
              
            }  
          }
        return ''
      }
      
    },
    setTableCellTitle(index,index1,card,store)
    {
      
      if(index > 3 && index1 < card.length -1 && store > 0)
      {
        return 'DOPPIO CLICK RICHIESTA TRASFERIMENTO'
      }
      if(index > 3 && index1 < card.length -1 && store == 0)
      {
        return 'DOPPIO CLICK SELEZIONA'
      }
    },
    setTableCellPointer(index,index1,card,store,item,col)
    {
      if(index > 3 && index1 < card.length -1  && store > 0  && item[col] > 0)
      {
        return 'pointer'
      }
      if(index > 3 && index1 < card.length -1  && store == 0  && item[col] > 0)
      {
        return 'pointer'
      }
    },  
    setTableCellClass(index,index1,card,store,item,col)
    {
      if(index > 3 && index1 < card.length -1  && store > 0  && item[col] > 0)
      {
        return 'active'
      }
      if(index > 3 && index1 < card.length -1  && store == 0  && item[col] > 0)
      {
        return 'active1'
      }
    }, 
    setData(storeId,colorId,size,index,color,store,qty,sender,row)
    {   
        
        if(sender == 0 && row == 0 && index > 3  && qty > 0)
        {
          for (let i = 0; i < this.barcodes.length ; i++) 
          {
            if(this.barcodes[i]['colorId'] == colorId && this.barcodes[i]['size'] == size)
            {
              
              const barcode = this.barcodes[i]['barcode']
        
              this.$emit('close',barcode)
              return

            }  
          }
        return  
        }
        
        
        
      
      if(row == 0 && index > 3 && sender > 0 && qty > 0)
      {
        this.booking.sender    = store
        this.booking.storeId   = storeId 
        this.booking.colorId   = colorId
        this.booking.color     = color
        this.booking.size      = size
        this.booking.form      = true
        this.booking.productId = this.item.productId  
        this.booking.store     = this.stores[0][0].store            
      }

    },

    close()
    {      
        this.$emit('close')       
    }

    }
  
}
</script>

<style scoped>


.table thead th {
  position    : sticky;
  background  : #cdd5db;
  
  z-index     : 10;
}



p{
  font-family: 'Roboto Condensed';
  _font-size: 22px;
}
span {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
h4 
{
  font-family: 'Roboto Condensed';
  font-size: 15px;
}
label
{
  font-family: 'Roboto Condensed';
  font-size: 25px;
}



.active:hover
{
  background-color:#ffc107;
}
.active1:hover
{
  background-color:rgb(19, 44, 231);
  color           : white;
}




_input[type=text]:disabled {
  
  
  background  : white;
  color       : navy;
  font-size   : 22px;
  border      : 0px solid;
   
}

.stock{
  _font-weight: bolder;
  _background  :#F5F5DC;
}
.card-header span
{
  display: flex;
  justify-content: center;
 
}
.scroll-div{
  position   : relative;
  height     : 500px;
  overflow   : auto;

  
}
.scroll-y {
display: block;
}


.store{
  
  background-color : #d3dfe8 !important;
  color: black !important;
}

.table,
.table th, 
.table td
{
  border-color: #3b28a7 !important;
}





.info-icon {
  position: relative;
  top: 2px;      /* angolo superiore */
  left: 2px;     /* angolo sinistro */
  cursor: pointer;
  font-size: 12px;
  color: white;
}





.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: white; /* IMPORTANTISSIMO */
  padding: 5px;
}



.container-fluid_ {
  max-height: 100vh;
  overflow-y: auto;
}

.table-container {
  max-height: 800px; /* o quello che vuoi */
  overflow-y: auto;
  position: relative;
}

.close-btn {
  position: sticky;
  top: 0;
  right: 0;
  float: right;
  z-index: 1000;

  background: white;
  border: 1px solid #ccc;
}





</style>